import React, { useState, useEffect, useCallback, useMemo } from "react";
import LeadsFilter from "./LeadsFilter";
import LeadsTable from "./LeadsTable";
import BankInclusionApprovalModal from "./BankInclusionApprovalModal";
import ReasonsModal from "./ReasonModal";
import BankInclusionStatCard from "./BankInclusionStatCard";

const BankInclusionListView = ({
  data,
  loading,
  summaryLoading,
  counts,
  activeTab,
  setActiveTab,
  searchTerm,
  setSearchTerm,
  currentPage,
  setCurrentPage,
  pageCount,
  focusedLead,
  setFocusedLead,
  focusedLeadIndex,
  setFocusedLeadIndex,
  handleDetailsClick,
  mutateBankInclusionList,
}) => {
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [isReasonModalOpen, setIsReasonModalOpen] = useState(false);

  const handleModalClose = useCallback(() => {
    setIsApprovalModalOpen(false);
    setFocusedLead(null);
    setFocusedLeadIndex(-1);
  }, [setFocusedLead, setFocusedLeadIndex]);

  const handleDetailsClickWithModal = useCallback(
    (bankInfoId) => {
      handleDetailsClick(bankInfoId);
      setIsApprovalModalOpen(true);
    },
    [handleDetailsClick],
  );
  const qcL1Stats = useMemo(() => {
    if (!counts.qc_l1) return [];

    const executedPercentage = counts.qc_l1.executed?.percentage || 0;
    const approvedPercentage = counts.qc_l1.approved?.percentage || 0;
    const rejectedPercentage = counts.qc_l1.rejected?.percentage || 0;

    return [
      {
        label: "Pending",
        value: counts.qc_l1.pending || 0,
        percentage: null,
      },
      {
        label: "Executed",
        value: counts.qc_l1.executed?.count || 0,
        percentage: executedPercentage,
      },
      {
        label: "Approved",
        value: counts.qc_l1.approved?.count || 0,
        percentage: approvedPercentage,
      },
      {
        label: "Rejected",
        value: counts.qc_l1.rejected?.count || 0,
        percentage: rejectedPercentage,
      },
    ];
  }, [counts.qc_l1]);

  const qcL2Stats = useMemo(() => {
    if (!counts.qc_l2) return [];

    const executedPercentage = counts.qc_l2.executed?.percentage || 0;
    const approvedPercentage = counts.qc_l2.approved?.percentage || 0;
    const sentBackPercentage = counts.qc_l2.sent_back?.percentage || 0;

    return [
      {
        label: "Pending",
        value: counts.qc_l2.pending || 0,
        percentage: null,
      },
      {
        label: "Executed",
        value: counts.qc_l2.executed?.count || 0,
        percentage: executedPercentage,
      },
      {
        label: "Approved",
        value: counts.qc_l2.approved?.count || 0,
        percentage: approvedPercentage,
      },
      {
        label: "Sent Back to L1",
        value: counts.qc_l2.sent_back?.count || 0,
        percentage: sentBackPercentage,
      },
      {
        label: "Rejected",
        value: counts.qc_l2.rejected?.count || 0,
        percentage: counts.qc_l2.rejected?.percentage || 0,
      },
    ];
  }, [counts.qc_l2]);

  return (
    <div className="leads-container">
      <div className="bank-inclusion-stats">
        <div className="stats-header">
          <h1 className="stats-title">Merchant Bank Inclusion Requests</h1>
        </div>

        <div className="stats-cards-container">
          <BankInclusionStatCard
            header="QC L1"
            items={qcL1Stats}
            loading={summaryLoading}
          />
          <BankInclusionStatCard
            header="QC L2"
            items={qcL2Stats}
            loading={summaryLoading}
          />
        </div>
      </div>
      <div className="leads">
        <LeadsFilter
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setActionReasonsModalOpen={setIsReasonModalOpen}
          allCount={counts.total}
          financeApprovalPendingCount={counts.finance_pending}
          csApprovalPendingCount={counts.cs_pending}
        />
        <LeadsTable
          data={data}
          loading={loading}
          error={false}
          page={currentPage}
          pageCount={pageCount}
          totalCount={counts.total}
          pageSize={10}
          focusedLeadIndex={focusedLeadIndex}
          onDetailsClick={handleDetailsClickWithModal}
          onPageChange={(page) => setCurrentPage(page)}
        />
        {isApprovalModalOpen && (
          <BankInclusionApprovalModal
            request={focusedLead}
            onClose={handleModalClose}
            mutateBankInclusionList={mutateBankInclusionList}
          />
        )}
        {isReasonModalOpen && (
          <ReasonsModal onClose={() => setIsReasonModalOpen(false)} />
        )}
      </div>
    </div>
  );
};

export default BankInclusionListView;
